<template>
  <el-container v-title data-title="年级信息" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>学校管理</el-breadcrumb-item>
                <el-breadcrumb-item>年级信息</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" @change="getGradeList" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="openAddDialog">新增</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="serviceFeeYuan" label="服务费（元）"></el-table-column>
          <el-table-column prop="startYear" label="开始年度"></el-table-column>
          <el-table-column prop="serviceFeeSwitchName" label="是否显示服务费"></el-table-column>
          <el-table-column prop="stopSendForExpiredName" label="是否对欠费学生发送考勤" width="180" v-if="['1'].indexOf(userInfo.userType) != -1"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="openModifyDialog(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getGradeList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（修改） -->
      <el-dialog
        title="修改"
        :visible.sync="modifyDialogVisible"
        width="420px"
        :before-close="handleClose">
        <el-form ref="modifyForm" :model="modifyData" :rules="rules" label-width="180px">
          <el-form-item label="名称" :required="true" prop="name">
            <el-input v-model="modifyData.name" style="width: 160px"></el-input>
          </el-form-item>
          <el-form-item label="开始年度" :required="true" prop="startYear">
            <el-input-number :min="2000" :max="2050" :precision="0" v-model="modifyData.startYear" style="width: 160px"></el-input-number>
          </el-form-item>
          <el-form-item label="服务费" :required="true" prop="serviceFeeYuan">
            <el-input-number :min="0" :max="999" :precision="0" v-model="modifyData.serviceFeeYuan" style="width: 160px"></el-input-number>
          </el-form-item>
          <el-form-item label="是否显示服务费" :required="true" prop="serviceFeeSwitch">
            <el-select v-model="modifyData.serviceFeeSwitch"  style="width: 120px">
              <el-option v-for="(item, index) in serviceFeeSwitchOptions" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否对欠费学生发送考勤" :required="true" prop="stopSendForExpired" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="modifyData.stopSendForExpired" style="width: 120px" placeholder="请选择">
              <el-option label="不停止" value="0"></el-option>
              <el-option label="停止" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="modifyGrade">修改</el-button>
            <el-button @click="modifyDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（新增） -->
      <el-dialog
        title="新增"
        :visible.sync="addDialogVisible"
        width="420px"
        :before-close="handleClose">
        <el-form ref="addForm" :model="addData" :rules="rules" label-width="180px">
          <el-form-item label="名称" :required="true" prop="name">
            <el-input v-model="addData.name" style="width: 160px"></el-input>
          </el-form-item>
          <el-form-item label="开始年度" :required="true" prop="startYear">
            <el-input-number :min="2000" :max="2050" :precision="0" v-model="addData.startYear" style="width: 160px"></el-input-number>
          </el-form-item>
          <el-form-item label="服务费（元）" :required="true" prop="serviceFeeYuan">
            <el-input-number :min="0" :max="999" :precision="0" v-model="addData.serviceFeeYuan" style="width: 160px"></el-input-number>
          </el-form-item>
          <el-form-item label="是否显示服务费" :required="true" prop="serviceFeeSwitch">
            <el-select v-model="addData.serviceFeeSwitch"  style="width: 120px">
              <el-option
                v-for="(item, index) in serviceFeeSwitchOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否对欠费学生发送考勤" :required="true" prop="stopSendForExpired" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="addData.stopSendForExpired" style="width: 120px" placeholder="请选择">
              <el-option label="不停止" value="0"></el-option>
              <el-option label="停止" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addGrade">新增</el-button>
            <el-button @click="addDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: ''
      },
      modifyData: {
      },
      modifyDialogVisible: false,
      addData: {
        'serviceFeeSwitch': '0'
      },
      addDialogVisible: false,
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        startYear: [{ required: true, message: '请输入开始年份', trigger: 'blur' }],
        serviceFeeYuan: [{ required: true, message: '请输入服务费', trigger: 'blur' }],
        serviceFeeSwitch: [{ required: true, message: '请选择是否显示服务费', trigger: 'change' }],
        stopSendForExpired: [{ required: true, message: '请选择是否对欠费学生发送考勤', trigger: 'change' }]
      },
      schoolList: [],
      serviceFeeSwitchOptions: [{
        value: '1',
        label: '显示'
      }, {
        value: '0',
        label: '隐藏'
      }]
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getGradeList()
    },
    openModifyDialog (gradeData) {
      this.modifyData = JSON.parse(JSON.stringify(gradeData))
      this.modifyDialogVisible = true
    },
    modifyGrade () {
      let _this = this
      _this.modifyData.schoolId = _this.searchForm.schoolId
      _this.modifyData.serviceFee = _this.modifyData.serviceFeeYuan * 100
      this.$refs['modifyForm'].validate((valid) => {
        if (valid) {
          this.$axios.post(this.GLOBAL.host + '/grade/update',
            _this.modifyData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.modifyDialogVisible = false
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                _this.getGradeList()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
      this.$refs['modifyForm'].resetFields()
    },
    openAddDialog () {
      this.addDialogVisible = true
    },
    addGrade () {
      let _this = this
      _this.addData.schoolId = _this.searchForm.schoolId
      _this.addData.serviceFee = _this.addData.serviceFeeYuan * 100
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.$axios.post(this.GLOBAL.host + '/grade/add',
            _this.addData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.addDialogVisible = false
                _this.addData = {}
                this.$message({
                  message: '新增成功',
                  type: 'success'
                })
                _this.getGradeList()
                _this.$refs['addForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getGradeList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getGradeList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/grade/list',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
            _this.tableData.forEach(gradeInfo => {
              if (gradeInfo.serviceFee != null) {
                gradeInfo.serviceFeeYuan = gradeInfo.serviceFee / 100
              }
            })
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Grade.vue